import { render, staticRenderFns } from "./StoreMenus.vue?vue&type=template&id=c8d00562&scoped=true&"
import script from "./StoreMenus.vue?vue&type=script&lang=js&"
export * from "./StoreMenus.vue?vue&type=script&lang=js&"
import style0 from "./StoreMenus.vue?vue&type=style&index=0&id=c8d00562&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d00562",
  null
  
)

export default component.exports